import {
  API_ERROR,
  REPORTS_MENU,
  REPORTS_MENU_SUCCESS,
  REPORT_TYPE_CHECK,
  SET_PARAMS,
  REPORT_INPUT_CHANGE_VALUE,
  REPORT_SELECT_CHANGEVALUE,
  MR_REPORTS_LIST,
  MR_REPORTS_LIST_SUCCESS,
  MR_DOC_REPORT,
  MR_DOC_REPORT_SUCCESS,
  PI_REPORTS_LIST,
  PI_REPORTS_LIST_SUCCESS,
  PI_DOC_REPORT,
  PI_DOC_REPORT_SUCCESS,
  RFQ_REPORTS_LIST,
  RFQ_REPORTS_LIST_SUCCESS,
  RFQ_DOC_REPORT,
  RFQ_DOC_REPORT_SUCCESS,
  RFQ_DOC_PDF,
  Q_REPORTS_LIST,
  Q_REPORTS_LIST_SUCCESS,
  Q_DOC_REPORT,
  Q_DOC_REPORT_SUCCESS,
  Q_DOC_PDF,
  CQ_REPORTS_LIST,
  CQ_REPORTS_LIST_SUCCESS,
  CQ_DOC_REPORT,
  CQ_DOC_REPORT_SUCCESS,
  PO_REPORTS_LIST,
  PO_REPORTS_LIST_SUCCESS,
  PO_ITEM_REPORTS_LIST,
  PO_ITEM_REPORTS_LIST_SUCCESS,
  PO_DOC_REPORT,
  PO_DOC_REPORT_SUCCESS,
  PENDING_PO_DOC_REPORT_SUCCESS,
  PO_DOC_PDF,
  IGP_REPORTS_LIST,
  IGP_REPORTS_LIST_SUCCESS,
  IGP_REPORTS_PO_LIST,
  IGP_REPORTS_PO_LIST_SUCCESS,
  IGP_DOC_REPORT,
  IGP_DOC_REPORT_SUCCESS,
  MR_ITEMS_REPORTS_LIST,
  MR_ITEMS_REPORTS_LIST_SUCCESS,
  VENDOR_REPORTS_LIST,
  VENDOR_REPORTS_LIST_SUCCESS,
  RFQ_PENDING_REPORTS_LIST,
  RFQ_PENDING_REPORTS_LIST_SUCCESS,
  ITEM_WISE_REPORTS_LIST,
  ITEM_WISE_REPORTS_LIST_SUCCESS,
  UNIT_REPORTS_LIST,
  UNIT_REPORTS_LIST_SUCCESS,
  UNIT_DOC_REPORT,
  UNIT_DOC_REPORT_SUCCESS,
  UNIT_DOC_PDF,
  PO_AMENDAMENT_REPORTS_LIST_SUCCESS,
  SR_DOC_REPORT_SUCCESS,
  SR_DOC_REPORT,
  SR_RFQ_DOC_PDF,
  SR_RFQ_REPORTS_LIST,
  SR_RFQ_REPORTS_LIST_SUCCESS,
  SR_RFQ_DOC_REPORT,
  SR_RFQ_DOC_REPORT_SUCCESS,
  SR_Q_DOC_PDF,
  SR_Q_DOC_REPORT,
  SR_Q_DOC_REPORT_SUCCESS,
  WO_DOC_REPORT,
  WO_DOC_REPORT_SUCCESS,
  WO_DOC_PDF,
  SR_REPORTS_LIST,
  SR_REPORTS_LIST_SUCCESS,
  SI_REPORTS_LIST,
  SI_REPORTS_LIST_SUCCESS,
  SI_DOC_REPORT,
  SI_DOC_REPORT_SUCCESS,
  SR_CQ_REPORTS_LIST,
  SR_CQ_REPORTS_LIST_SUCCESS,
  SRQ_REPORTS_LIST,
  SRQ_REPORTS_LIST_SUCCESS,
  WO_REPORTS_LIST,
  WO_REPORTS_LIST_SUCCESS,
  REPORT_STATUS,
  DELAY_REPORTS_LIST,
  REPORT_DOWNLOAD_SUCCESS,
  PO_REPORTS_LIST_FOR_DOCUMENT,
  PO_REPORTS_LIST__FOR_DOCUMENT_SUCCESS,
  PENDING_PO_DOC_REPORT,
  CONSUMPTION_DETAILED_DOC_REPORT,
  CONSUMPTION_DETAILED_DOC_REPORT_SUCCESS,
  VENDOR_DUE_DETAILED_DOC_REPORT,
  VENDOR_DUE_DETAILED_DOC_REPORT_SUCCESS,
} from "./actionTypes";

const initialState = {
  reportMenu: [],
  MR_ReportData: [],
  SR_ReportData: [],
  MR_Doc_report: {},
  SR_Doc_report: {},
  PI_ReportData: [],
  SI_ReportData: [],
  PI_Doc_report: {},
  SI_Doc_report: {},
  RFQ_ReportData: [],
  columnsList: [],
  RFQ_Doc_report: {},
  SR_RFQ_ReportData: [],
  SR_RFQ_Doc_report: {},
  rfqPDF: false,
  srfqPDF: false,

  Q_ReportData: [],
  SRQ_ReportData: [],
  Q_Doc_report: {},
  SR_Q_Doc_report: {},
  QuotationPdf: false,
  SRQuotationPdf: false,

  CQ_ReportData: [],
  SR_CQ_ReportData: [],
  CQ_Doc_report: {},
  PO_ReportData: [],
  WO_ReportData: [],
  PO_Amendament_ReportData: [],
  PO_ItemReportData: [],
  PO_Doc_report: {},
  Pending_PO_Doc_Report: {},
  Consumtion_Doc: {},
  Vendor_Due_Report: {},
  WO_Doc_report: {},

  POPdf: false,
  pdfType: "",

  IGP_ReportData: [],
  IGP_Doc_report: {},

  reportType: "list",
  params: {
    no_of_pages: 0,
    page_size: 10,
    page: 1,
    search: "",
  },
  Reportdata: {},

  ///
  CompareQuotation: {},
  Quotation: [],
  RequestForQuotation: {},
  CQbodyData: [],
  CQBodyTCData: [],

  MR_Items_ReportData: [],
  Vendor_ReportData: [],
  Rfq_pending_ReportData: [],
  Item_Wise_ReportData: [],

  Unit_ReportData: [],
  Unit_Doc_report: {},
  UnitPdf: false,
};

const Report = (state = initialState, action) => {
  switch (action.type) {
    case REPORTS_MENU:
      state = {
        ...state,
        loading: true,
      };
      break;
    case REPORTS_MENU_SUCCESS:
      state = {
        ...state,
        reportMenu: action.payload,
        loading: false,
      };
      break;

    case REPORT_TYPE_CHECK:
      state = {
        ...state,
        reportType: action.payload.value,
      };
      break;
    case SET_PARAMS:
      state = {
        ...state,
        params: action.payload,
        Reportdata: {},
      };
      break;
    case REPORT_INPUT_CHANGE_VALUE:
      state = {
        ...state,
        params: {
          ...state.params,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case REPORT_SELECT_CHANGEVALUE:
      state = {
        ...state,
        Reportdata: {
          ...state.Reportdata,
          [action.payload.key]: action.payload.label,
        },
        params: {
          ...state.params,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case MR_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case MR_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        MR_ReportData: action.payload,
        loading: false,
      };
      break;
    case SR_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        SR_ReportData: action.payload,
        loading: false,
      };
      break;
    case MR_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case MR_DOC_REPORT_SUCCESS:
      var mr_approvals = [];
      mr_approvals = action.payload.mr_approvals.filter((approvale) => {
        if (approvale.mrstatus === 3) {
          return approvale.approvedby;
        }
        return 0;
      });

      state = {
        ...state,
        MR_Doc_report: {
          ...action.payload,
          userDeptApprovedby: mr_approvals,
        },
        loading: false,
      };
      break;
    case SR_DOC_REPORT_SUCCESS:
      console.log("actin payload doc", action.payload);
      var sr_approvals = [];
      sr_approvals = action.payload.sr_approvals.filter((approvale) => {
        if (approvale.srstatus === 3) {
          return approvale.approvedby;
        }
        return 0;
      });

      state = {
        ...state,
        SR_Doc_report: {
          ...action.payload,
          userDeptApprovedby: sr_approvals,
        },
        loading: false,
      };
      break;
    case PI_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case PI_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        PI_ReportData: action.payload,
        loading: false,
      };
      break;
    case PI_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case PI_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        PI_Doc_report: action.payload,
        loading: false,
      };
      break;
    case SI_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SI_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        SI_ReportData: action.payload,
        loading: false,
      };
      break;
    case SI_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SI_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        SI_Doc_report: action.payload,
        loading: false,
      };
      break;
    case RFQ_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case RFQ_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        RFQ_ReportData: action.payload,
        loading: false,
      };
      break;
    case RFQ_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case RFQ_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        RFQ_Doc_report: action.payload,
        loading: false,
      };
      break;

    case SR_RFQ_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_RFQ_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        SR_RFQ_ReportData: action.payload,
        loading: false,
      };
      break;
    case SR_RFQ_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_RFQ_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        SR_RFQ_Doc_report: action.payload,
        loading: false,
      };
      break;
    case SR_RFQ_DOC_PDF:
      state = {
        ...state,
        rfqPDF: action.payload.rfqPdf,
        loading: false,
      };
      break;
    case Q_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case Q_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        Q_ReportData: action.payload,
        loading: false,
      };
      break;
    case SRQ_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SRQ_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        SRQ_ReportData: action.payload,
        loading: false,
      };
      break;
    case Q_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case Q_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        Q_Doc_report: action.payload,
        loading: false,
      };
      break;
    case SR_Q_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_Q_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        SR_Q_Doc_report: action.payload,
        loading: false,
      };
      break;

    case Q_DOC_PDF:
      state = {
        ...state,
        QuotationPdf: action.payload.QuotationPdf,
        loading: false,
      };
      break;
    case SR_Q_DOC_PDF:
      state = {
        ...state,
        SRQuotationPdf: action.payload.QuotationPdf,
        loading: false,
      };
      break;
    // Unit Wise Pending Report
    case UNIT_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case UNIT_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        Unit_ReportData: action.payload.results,
        loading: false,
      };
      break;
    case UNIT_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case UNIT_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        Unit_Doc_report: action.payload,
        loading: false,
      };
      break;
    case UNIT_DOC_PDF:
      state = {
        ...state,
        UnitPdf: action.payload.UnitPdf,
        loading: false,
      };
      break;
    //
    case CQ_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CQ_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        CQ_ReportData: action.payload,
        loading: false,
      };
      break;
    case SR_CQ_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_CQ_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        SR_CQ_ReportData: action.payload,
        loading: false,
      };
      break;
    case CQ_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CQ_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        // CQ_Doc_report: action.payload,
        CompareQuotation: action.payload.CompareQuotation,
        Quotation: action.payload.Quotation,
        RequestForQuotation: action.payload.RequestForQuotation,
        loading: false,
      };

      //  RequestForQuotation
      state.RFQCellData = [
        { vendId: 0, CellName: "ItemName", headerName: "Item Name" },
      ];

      state.RequestForQuotation.rfqvendors.map((vend, i) => {
        var Hcelldata = {
          CellName: "Vendor" + vend.vendor.id,
          headerName: vend.vendor.name,
          vendId: vend.vendor.id,
        };
        state.RFQCellData.push(Hcelldata);
        return 0;
      });

      state.CQbodyData = state.RequestForQuotation.rfqitems.map((item) => {
        return {
          ItemName: {
            rfqItemId: item.id,
            product_id: item.product.id,
            Name: item.product.name,
            Quantity: item.qty,
            Quantity_unit: {
              units: item.unit.units,
              name: item.unit.name,
            },
            totalqty: 0,
          },
        };
      });
      // Quotation

      var rfqItemIds = state.CQbodyData.map((item) => {
        return item.ItemName.rfqItemId;
      });
      state.CQBodyTCData = [{ ItemName: "Terms & Conditions" }];
      state.Quotation.forEach((q, key) => {
        q.qitems.forEach((item, j) => {
          var i = rfqItemIds.indexOf(item.rfqitem);

          state.CQbodyData[i]["Vendor" + q.vendor.id] = {
            Quantity: item.originalqty,
            unit: { id: item.unit.id, name: item.unit.name },
            Price: item.price,
            GrossValue: item.gross,
            GST: item.tax.name,
            tax: item.tax.tax,
            tax_id: item.tax.id,
            taxtype: item.taxtype,
            qitem_id: item.id,
            ApprovedQuantity: 0,
            updateGrossValue: 0,
            index: i,
            quotation_id: q.id,
            vendorId: q.vendor.id,
            Quotationcheck: false,
          };

          // if (q.qitems.length - 1 === j && state.Quotation.length - 1 === key) {
          //   state.loading = false;
          // }
        });
        state.CQBodyTCData[0]["Vendor" + q.vendor.id] = q.terms;
        if (state.CompareQuotation.cqitems) {
          if (key + 1 === state.Quotation.length) {
            state.CompareQuotation.cqitems.forEach((item, index) => {
              var i = rfqItemIds.indexOf(item.rfqitem);
              state.CQbodyData[i]["Vendor" + item.vendor.id]["id"] = item.id;
              state.CQbodyData[i]["Vendor" + item.vendor.id][
                "ApprovedQuantity"
              ] = item.qty;
              state.CQbodyData[i]["Vendor" + item.vendor.id][
                "Quotationcheck"
              ] = true;
              state.CQbodyData[i]["Vendor" + item.vendor.id][
                "updateGrossValue"
              ] = item.gross;
              state.CQbodyData[i]["ItemName"]["totalqty"] += parseInt(item.qty);
            });
          }
        }
      });

      break;
    //
    case PO_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case PO_REPORTS_LIST_SUCCESS: {
      let poList = [];
      // Define default params
      const defaultParams = {
        no_of_pages: 0,
        page_size: 10, // Changed to 20 as per your fallback
        page: 1,
        search: "",
      };
      // Merge existing params with defaults to ensure all fields are present
      const params = {
        ...defaultParams,
        ...(state.params || {}), // Spread state.params to override defaults if present
      };
      // Calculate number of pages
      const count = action.payload?.count || 0; // Default to 0 if undefined
      const pageSize = params.page_size || 10; // Ensure page_size is defined
      const poNoofpages = Math.ceil(count / pageSize);
      // Determine columnsList
      let columnsList = state.columnsList;
      if (action.payload.results?.length > 0 && params.page === 1) {
        columnsList = Object.keys(action.payload.results[0]);
      }

      // Update poList
      if (params.page === 1) {
        poList = action.payload.results || [];
      } else {
        const combinedList = [...(action.payload?.results || [])];
        poList = combinedList;
      }
      return {
        ...state,
        PO_ReportData: poList,
        columnsList: columnsList,
        params: {
          ...params,
          no_of_pages: poNoofpages,
        },
        loading: false,
      };
    }
    case PO_REPORTS_LIST_FOR_DOCUMENT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case PO_REPORTS_LIST__FOR_DOCUMENT_SUCCESS: {
      let poList = [];
      // Define default params
      const defaultParams = {
        no_of_pages: 0,
        page_size: 10, // Changed to 20 as per your fallback
        page: 1,
        search: "",
      };
      // Merge existing params with defaults to ensure all fields are present
      const params = {
        ...defaultParams,
        ...(state.params || {}), // Spread state.params to override defaults if present
      };
      // Calculate number of pages
      const count = action.payload?.count || 0; // Default to 0 if undefined
      const pageSize = params.page_size || 10; // Ensure page_size is defined
      const poNoofpages = Math.ceil(count / pageSize);
      // Determine columnsList
      let columnsList = state.columnsList;
      if (action.payload.results?.length > 0 && params.page === 1) {
        columnsList = Object.keys(action.payload.results[0]);
      }

      // Update poList
      if (params.page === 1) {
        poList = action.payload.results || [];
      } else {
        const combinedList = state.PO_ReportData.concat(
          action.payload?.results
        );
        poList = combinedList;
      }
      return {
        ...state,
        PO_ReportData: poList,
        columnsList: columnsList,
        params: {
          ...params,
          no_of_pages: poNoofpages,
        },
        loading: false,
      };
    }
    case REPORT_DOWNLOAD_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
    case REPORT_STATUS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DELAY_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case WO_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case WO_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        WO_ReportData: [],
      };
      let list = [];

      // Calculate the number of pages
      const noofpages = Math.ceil(
        action.payload.count / state.params.page_size
      );

      if (state.params.page === 1) {
        // If this is the first page, replace the list with the new results
        list = action.payload.results;
      } else {
        // Concatenate and filter duplicates by id
        const combinedList = [
          ...state.WO_ReportData,
          ...action.payload?.results,
        ];

        const uniqueList = combinedList.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.id === item.id)
        );
        list = uniqueList;
      }

      state = {
        ...state,
        WO_ReportData: list,
        params: {
          ...state.params,
          no_of_pages: noofpages,
        },
        loading: false,
      };
      break;

    case PO_AMENDAMENT_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        PO_Amendament_ReportData: action.payload,
        loading: false,
      };
      break;
    case PO_ITEM_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case PO_ITEM_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        PO_ItemReportData: action.payload,
        loading: false,
      };
      break;
    case PO_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case PO_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        PO_Doc_report: action.payload,
        loading: false,
      };
      break;
    case PENDING_PO_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case PENDING_PO_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        Pending_PO_Doc_Report: action.payload,
        loading: false,
      };
      break;
    case CONSUMPTION_DETAILED_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CONSUMPTION_DETAILED_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        Consumtion_Doc: action.payload,
        loading: false,
      };
      break;
    case VENDOR_DUE_DETAILED_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case VENDOR_DUE_DETAILED_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        Vendor_Due_Report: action.payload,
        loading: false,
      };
      break;

    case PO_DOC_PDF:
      state = {
        ...state,
        POPdf: action.payload.POPdf,
        pdfType: action.payload.pdfType,
        loading: false,
      };
      break;

    case WO_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case WO_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        WO_Doc_report: action.payload,
        loading: false,
      };
      break;

    case WO_DOC_PDF:
      state = {
        ...state,
        POPdf: action.payload.POPdf,
        pdfType: action.payload.pdfType,
        loading: false,
      };
      break;
    //IGP
    case IGP_REPORTS_LIST:
      state = {
        ...state,
        IGP_ReportData: [],
        loading: true,
      };
      break;
    case IGP_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        IGP_ReportData: action.payload,
        loading: false,
      };
      break;
    case IGP_REPORTS_PO_LIST:
      state = {
        ...state,
        IGP_ReportData: [],
        loading: true,
      };
      break;
    case IGP_REPORTS_PO_LIST_SUCCESS:
      var IGP_ReportDataPOWise = [];
      action.payload.forEach((igp) => {
        igp.grn2pos.forEach((grn2po) => {
          IGP_ReportDataPOWise.push({
            IGP_Code: igp.code,
            personname: igp.personname,
            grn2items: igp.grn2items,
            vehicleno: igp.vehicleno,
            purchaseorder_code: grn2po.purchaseorder_code,
            vendorName: grn2po.vendor.name,
            createdon: igp.createdon,
            createdby:
              igp.createdby.fullname + "(" + igp.createdby.username + ")",
          });
        });
      });
      state = {
        ...state,
        IGP_ReportData: IGP_ReportDataPOWise,
        loading: false,
      };
      break;
    case IGP_DOC_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case IGP_DOC_REPORT_SUCCESS:
      var attachment = [];
      attachment = action.payload.grn2pos.map((grn) => {
        if (grn.bill_image != null) {
          return grn.bill_image.file; // attachment.push(grn.bill_image.file);
        }
        return null;
      });

      state = {
        ...state,
        IGP_Doc_report: { ...action.payload, attachment: attachment },
        loading: false,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;

    // MR ITEMS REPORTS

    case MR_ITEMS_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case MR_ITEMS_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        MR_Items_ReportData: action.payload,
        loading: false,
      };
      break;

    // Vendor List Reports

    case VENDOR_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case VENDOR_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        Vendor_ReportData: action.payload,
        loading: false,
      };
      break;

    // RFQ Pending Items Reports

    case RFQ_PENDING_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case RFQ_PENDING_REPORTS_LIST_SUCCESS:
      var rfq_Vendordata = [];
      action.payload.forEach((rfqItem) => {
        rfqItem.rfqvenders.forEach((rfqvenders) => {
          rfq_Vendordata.push({
            code: rfqItem.code,
            date: rfqItem.date,
            productname: rfqItem.productname,
            productdescription: rfqItem.productdescription,
            qty: rfqItem.qty,
            productdepartment: rfqItem.productdepartment,
            vendor_name: rfqvenders.vendor?.name,
            vendor_code: rfqvenders.vendor?.code,
            vendor_date: rfqvenders.vendor?.createdon,
            vendor_location: rfqvenders.vendor?.address,
            no_due_dates: rfqvenders.no_due_dates,
            rfqstatus_name: rfqItem.rfqstatus_name,
          });
        });
      });

      state = {
        ...state,
        Rfq_pending_ReportData: rfq_Vendordata,
        loading: false,
      };
      break;

    // Item Wise Reports

    case ITEM_WISE_REPORTS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case ITEM_WISE_REPORTS_LIST_SUCCESS:
      state = {
        ...state,
        Item_Wise_ReportData: action.payload,
        loading: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }

  return state;
};
export default Report;
